import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import CustomizeUIStore from '../../stores/CustomizeUI/CustomizeUIStore';
import { Field, FTHeading, Card } from '../Fuse';
import NewFuseWysiwyg from '../Fuse/NewFuseWysiwyg';
import FuseReadOnlySwitch from '../FuseControls/FuseReadOnlySwitch';
import { FuseConsoleField } from '../ConsoleFragments';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import BaseCustomizeEditModal from './BaseCustomizeEditModal';

export const registerNoticeTooltipInfo = 'Display a notice during the registration' +
    ' process that requires the user to accept the terms before' +
    ' proceeding to register. links to your organization’s documents can be included in the message.';

class CustomizeRegistrationNoticeModal extends Component {
    static propTypes = {
        customizeUI: CustomizeUIStore.PropType.isRequired,
    };
    render() {
        const { registrationNotice } = this.props.customizeUI;
        return <BaseCustomizeEditModal noPreview={!registrationNotice.enabled.getValue()} store={registrationNotice}>
            <Card style={{ padding: 20 }}>
                <FTHeading style={{ marginBottom: 20 }}>Registration Notice</FTHeading>
                <FuseConsoleField
                    name="Registration Notice Option"
                    info="Display a notice during the registration process that requires the user to accept the terms
                        before proceeding to register. links to your organization’s documents
                        can be included in the message."
                    infoPosition="bottom"
                >
                    <FuseReadOnlySwitch
                        style={{ paddingTop: 11 }}
                        store={registrationNotice.enabled}
                        label={registrationNotice.enabled.getValue() ? 'Enabled' : 'Disabled'}
                        qa="registration-notice-enabled-switch"
                    />
                </FuseConsoleField>
                {registrationNotice.enabled.getValue() ? <>
                    <Field
                        style={{ paddingTop: 20, paddingBottom: 20 }}
                        label="Message"
                        caption="&nbsp;(required)"
                    >
                        <NewFuseWysiwyg store={registrationNotice.content}/>
                    </Field>
                    <FuseConsoleCardFooter text="Text will not be translated to other languages." />
                </> : null }
            </Card>
        </BaseCustomizeEditModal>;
    }
}
export default inject('customizeUI')(observer(CustomizeRegistrationNoticeModal));
